import AbstractModel from '../AbstractModel';

class ProjectPublicDataModel extends AbstractModel {}

export default ProjectPublicDataModel;
